import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatTooltip } from '@angular/material/tooltip';
import { InfoDisplayPipe } from '@iot-platform/pipes';
import { TranslatePipe } from '@ngx-translate/core';
import { BaseCardDetailsWidgetComponent } from '../base-card-details-widget/base-card-details-widget.component';

@Component({
  imports: [FlexLayoutModule, TranslatePipe, MatTooltip, BaseCardDetailsWidgetComponent, NgTemplateOutlet, AsyncPipe, InfoDisplayPipe],
  selector: 'iot-platform-ui-card-details-widget',
  templateUrl: './card-details-widget.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./card-details-widget.component.scss']
})
export class CardDetailsWidgetComponent extends BaseCardDetailsWidgetComponent {}
